import { render } from "./RentalsStatement.vue?vue&type=template&id=49ce404c&scoped=true"
import script from "./RentalsStatement.vue?vue&type=script&lang=js"
export * from "./RentalsStatement.vue?vue&type=script&lang=js"

import "./RentalsStatement.vue?vue&type=style&index=0&id=49ce404c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ce404c"]])

export default __exports__